import type { Nullable } from '@iheartjane/types';

import type { ImageBannerViewModel } from '@jane/bloom/viewModels/communicationBanner';

import styles from './imageBanner.module.css';

type ImageBannerProps = {
  communicationBanner: Nullable<ImageBannerViewModel>;
};

export function ImageBanner({ communicationBanner }: ImageBannerProps) {
  if (!communicationBanner) return null;

  return (
    <div className={styles['container']}>
      <img
        title="Communication banner background image"
        alt=""
        style={{
          opacity: communicationBanner.image_opacity
            ? communicationBanner.image_opacity / 100
            : 1,
        }}
        src={communicationBanner.fallbackSrc}
        srcSet={communicationBanner.srcSet}
        sizes={communicationBanner.sizes}
        className={styles['backgroundImage']}
        loading="eager"
        height="240px"
        width="100%"
        decoding="auto"
      />
      <h1
        style={{
          color: `#${communicationBanner.header_text_color}`,
        }}
      >
        {communicationBanner.title}
      </h1>
      {communicationBanner.button_link && (
        <button
          className={styles['cta']}
          style={{
            backgroundColor: `#${communicationBanner.button_fill_color}`,
            color: `#${communicationBanner.button_text_color}`,
          }}
          onClick={() => {
            let url = communicationBanner.button_link ?? '';
            if (!/^https?:\/\//i.test(url)) {
              url = 'http://' + url;
            }
            window.open(url);
          }}
        >
          {communicationBanner.button_text}
        </button>
      )}
    </div>
  );
}
